(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/components/expandable-game-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/components/expandable-game-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useRef = _React.useRef;
const Icon = svs.ui.ReactIcon;
const Button = svs.ui.Button;
const NOOP = () => {};
const MOBILE_BREAKPOINT_QUERY = '(max-width: 767px)';
const TABLET_BREAKPOINT_QUERY = '(min-width: 768px)';
const EXPANDED_TOP_GAP_PX = 8;
const ExpandableGameWrapper = _ref => {
  let expandBackground = _ref.expandBackground,
    _ref$isGameLoaded = _ref.isGameLoaded,
    isGameLoaded = _ref$isGameLoaded === void 0 ? true : _ref$isGameLoaded,
    _ref$onExpandChange = _ref.onExpandChange,
    onExpandChange = _ref$onExpandChange === void 0 ? NOOP : _ref$onExpandChange,
    outerRef = _ref.outerRef,
    children = _ref.children;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    scale = _useState4[0],
    setScale = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    expandedViewportTop = _useState6[0],
    setExpandedViewportTop = _useState6[1];
  const gameRef = useRef(null);
  const originalScrollRef = useRef(null);
  const calculateTargetScale = useCallback(function () {
    let topOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!gameRef.current) {
      return 1;
    }
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const gameWidth = gameRef.current.offsetWidth || 1;
    const gameHeight = gameRef.current.offsetHeight || 1;
    const availableHeight = Math.max(vh - topOffset, 1);
    const widthScale = vw / gameWidth;
    const heightScale = availableHeight / gameHeight;
    const isMobileViewport = window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches;

    if (isMobileViewport) {
      return widthScale;
    }
    return Math.min(widthScale, heightScale);
  }, []);
  const getExpandedTopOffset = useCallback(() => {
    var _outerRef$current;
    const topbar = outerRef === null || outerRef === void 0 || (_outerRef$current = outerRef.current) === null || _outerRef$current === void 0 ? void 0 : _outerRef$current.querySelector('.next-play-topbar');
    if (!topbar) {
      return EXPANDED_TOP_GAP_PX;
    }
    const _topbar$getBoundingCl = topbar.getBoundingClientRect(),
      bottom = _topbar$getBoundingCl.bottom;
    return Math.round(bottom + EXPANDED_TOP_GAP_PX);
  }, [outerRef]);
  const collapse = useCallback(() => {
    setIsExpanded(false);
    onExpandChange(false);
    setScale(1);
    setExpandedViewportTop(0);
    document.body.classList.remove('ticket-expand--body-lock');
    if (outerRef !== null && outerRef !== void 0 && outerRef.current) {
      outerRef.current.classList.remove('ticket-expand--no-transform');
      outerRef.current.style.removeProperty('--expand-bg');
    }
    if (originalScrollRef.current) {
      requestAnimationFrame(() => window.scrollTo(0, originalScrollRef.current.scrollY));
    }
  }, [onExpandChange, outerRef]);
  useEffect(() => {
    const mediaQuery = window.matchMedia(TABLET_BREAKPOINT_QUERY);
    const handleChange = e => {
      if (e.matches && isExpanded) {
        collapse();
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [isExpanded, collapse]);
  const expand = useCallback(() => {
    if (!gameRef.current) {
      return;
    }
    originalScrollRef.current = {
      scrollY: window.scrollY
    };
    if (outerRef !== null && outerRef !== void 0 && outerRef.current) {
      outerRef.current.classList.add('ticket-expand--no-transform');
      if (expandBackground) {
        outerRef.current.style.setProperty('--expand-bg', "url(".concat(expandBackground, ")"));
      }
    }
    const topOffset = getExpandedTopOffset();
    const targetScale = calculateTargetScale(topOffset);
    setExpandedViewportTop(topOffset);

    setScale(1);
    document.body.classList.add('ticket-expand--body-lock');
    window.scrollTo(0, 0);
    onExpandChange(true);
    setIsExpanded(true);
    requestAnimationFrame(() => {
      setScale(targetScale);
    });
  }, [onExpandChange, outerRef, expandBackground, getExpandedTopOffset, calculateTargetScale]);
  const toggleExpand = useCallback(() => {
    if (isExpanded) {
      collapse();
      return;
    }
    expand();
  }, [isExpanded, collapse, expand]);
  useEffect(() => {
    if (!isExpanded) {
      return;
    }
    const updateExpandedLayout = () => {
      const topOffset = getExpandedTopOffset();
      setExpandedViewportTop(topOffset);
      setScale(calculateTargetScale(topOffset));
    };
    updateExpandedLayout();
    window.addEventListener('resize', updateExpandedLayout);
    window.addEventListener('orientationchange', updateExpandedLayout);
    return () => {
      window.removeEventListener('resize', updateExpandedLayout);
      window.removeEventListener('orientationchange', updateExpandedLayout);
    };
  }, [isExpanded, getExpandedTopOffset, calculateTargetScale]);
  const expandedViewportStyle = isExpanded ? {
    top: "".concat(expandedViewportTop, "px"),
    height: "calc(100vh - ".concat(expandedViewportTop, "px)")
  } : undefined;
  return React.createElement(React.Fragment, null, isExpanded && React.createElement("div", {
    className: "ticket-expand__overlay"
  }, expandBackground && React.createElement("div", {
    className: "ticket-expand__bg",
    style: {
      backgroundImage: "url(".concat(expandBackground, ")")
    }
  })), React.createElement("div", {
    className: isExpanded ? 'ticket-expand__fullscreen' : 'ticket-expand relative padding-top-1',
    style: expandedViewportStyle
  }, React.createElement("div", {
    className: "ticket-expand__game",
    ref: gameRef,
    style: isExpanded ? {
      transform: "scale(".concat(scale, ")"),
      transformOrigin: 'top center'
    } : undefined
  }, !isExpanded && isGameLoaded && React.createElement(Button, {
    "aria-label": "F\xF6rstora lotten",
    className: "qa-ticket-expand-btn ticket-expand__expand-btn",
    "data-testid": "ticket-expand-btn",
    onClick: toggleExpand,
    type: "button"
  }, React.createElement(Icon, {
    color: "fc-black",
    icon: "expand",
    size: "100"
  })), isExpanded && React.createElement(Button, {
    "aria-label": "F\xF6rminska lotten",
    className: "qa-ticket-expand-collapse-btn ticket-expand__collapse-btn",
    "data-testid": "ticket-expand-collapse-btn",
    onClick: toggleExpand,
    size: "100",
    type: "button"
  }, React.createElement(Icon, {
    color: "fc-black",
    icon: "collapse",
    size: "100"
  })), children), !isExpanded && React.createElement("div", {
    className: "ticket-expand__shadow"
  })));
};
setGlobal('svs.tickets.next.areas.play.components.ExpandableGameWrapper', ExpandableGameWrapper);

 })(window);